module.exports = __webpack_public_path__ + "static/media/inviteafriend.6cc02f79.png";